exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("../../resources/new-york.jpg"));
// Module
exports.push([module.id, "._2FzQipAGSqdxEAWSytTNXi {\r\n    opacity: 0.51;\r\n    background-image: url(" + ___CSS_LOADER_URL___0___ + ");\r\n    height: 100%;\r\n    width:100%;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    margin: 0;\r\n    font: 400 15px/1.8 \"Lato\", sans-serif;\r\n    color: #777;\r\n    position: absolute;\r\n    z-index:-1;\r\n}\r\n\r\n._2j1GyEv1Lhx8GMYbJP-FQa {\r\n    opacity: 1;\r\n}\r\n", ""]);
// Exports
exports.locals = {
	"bg": "_2FzQipAGSqdxEAWSytTNXi",
	"content": "_2j1GyEv1Lhx8GMYbJP-FQa"
};